import { createContext } from './createContext';
import { renderApplication } from '../renderApplication';
import { createApplicationState } from '../applicationState';

export function runApp() {
  const context = createContext();
  const store = createApplicationState(context);

  renderApplication({ store, context });
}
